import { useResourceNameModal } from '@hooks/useModal'
import { useCreateProject } from './useProjectManagement'
import { useTranslation } from 'react-i18next'

export const useNewProject = () => {
  const { openResourceNameModal } = useResourceNameModal()
  const createProject = useCreateProject()
  const { t } = useTranslation()

  const newProject = () => {
    openResourceNameModal({
      title: t('features.projectsAdmin.addProject'),
      inputLabel: t('features.projectsAdmin.projectName'),
      onSave: async (name: string) => {
        await createProject.mutateAsync({ name })
      },
      isSaving: createProject.isLoading,
      toastMessages: {
        success: {
          title: t('features.projectsAdmin.projectCreated'),
          content: (name) => t('features.projectsAdmin.successfullyCreatedProject', { name }),
        },
        error: {
          title: t('features.projectsAdmin.unableToCreateProject'),
          content: t('features.projectsAdmin.failedToCreateProject'),
        },
      },
    })
  }

  return { newProject }
}
